import qs from 'qs';
import Cookies from 'js-cookie';
const TOKEN = "token";
const rootHost = window.location.hostname
  .split(".")
  .slice(-2)
  .join(".");
const util = {
  misHost: null,
  tokenReg: new RegExp(`;?${TOKEN}=([^;\b]+)`),
  getTokenFromLocalStorage() {
    const token = window.localStorage.getItem(TOKEN);
    if (token && (token === "''" || token === '""' || token === "undefined")) {
      return null;
    }
    return token;
  },
  getTokenFromCookie() {
    return Cookies.get(TOKEN);
  },
  getTokenFromQuerystring() {
    const token = (window.location.search.match(this.tokenReg) || [])[1];
    if (token && (token === "''" || token === '""' || token === "undefined")) {
      return null;
    }
    return token;
  },
  getMisHost() {
    let misHost = this.misHost;
    if (misHost) {
      return misHost;
    }
    const protocol = window.location.protocol;
    misHost = `${protocol}//iu-web.mymishang.com`;
    switch (this.getEnv()) {
      case "dev":
        misHost = `${protocol}//dev-iu-web.mymishang.com`;
        break;
      case "newtest":
        misHost = `${protocol}//newtest-iu-web.mymishang.com`;
        break;
      case "pre":
        misHost = `${protocol}//pre-iu-web.mymishang.com`;
        break;
      case "localhost":
        misHost = "http://newtest-iu-web.mymishang.com"; // window.location.origin;
        break;
      default:
        misHost = `${protocol}//iu-web.mymishang.com`;
    }
    this.misHost = misHost;
    return misHost;
  },
  getEnv() {
    if (/^localhost$/.test(window.location.hostname)) {
      return process.env.VUE_APP_MIS_ENV
    }
    const envEnum = [
      /(dev)[-.]/,
      /(newtest)[-.]/,
      /(pre)[-.]/,
    ];
    for (let i = 0; i < 4; i++) {
      const match = window.location.hostname.match(envEnum[i]);
      if (match && match[1]) {
        return match[1];
      }
    }
    return null;
  },
  jumpHref(route, params) {
    if (!params.redirect_url) {
      params.redirect_url = this.redirectUrl("/");
    }
    return `${util.getMisHost()}#${route}?${this.parseObj(params)}`;
  },
  redirectUrl(toPath) {
    if (/^https?:\/\/.+/.test(toPath)) {
      return encodeURIComponent(toPath);
    }
    return encodeURIComponent(`${window.location.origin}/#${toPath}`);
  },
  parseObj(obj = {}) {
    const str = [];
    for (const k in obj) {
      if (obj[k]) {
        str.push(`${k}=${obj[k]}`);
      }
    }
    return str.join("&");
  },
  replaceUrl(href) {
    window.location.replace(href);
    // window.history.replaceState(redirectUrl)
  }
};

const mis = {
  token() {
    const token = this.getToken();
    this.setToken(token);
    const href = window.location.href.replace(/&?token=[^&#]+/g, "");
    if (window.history.replaceState) {
      window.history.replaceState(null, null, href);
    } else {
      util.replace(href);
    }
  },
  /**
   * 保存token到 cookie(根域名节点下) 和 localStorage
   * @param {string} token
   */
  setToken(token) {
    if (token) {
      document.cookie = `${TOKEN}=${token};path=/;domain=${rootHost}`;
      window.localStorage.setItem(TOKEN, token);
      const middleWin = document.querySelector('middle');
      if (middleWin) {
        middleWin.postMessage({
          token,
        })
      }
    }
  },
  /**
   * 获取token， 获取源顺序为 localStorage,  cookie ,  querystring
   */
  getToken() {
    return (
      util.getTokenFromQuerystring() ||
      util.getTokenFromCookie() ||
      util.getTokenFromLocalStorage()
    );
  },
  /**
   * 删除 cookie 和 localStorage 中的token;
   */
  removeToken() {
    window.localStorage.removeItem(TOKEN);
    window.localStorage.removeItem('userId');//移除userId
    document.cookie = `${TOKEN}=;path=/;domain=${rootHost}; expires=Thu, 01 Jan 1970 00:00:00 GMT`; //清除cookie
  },
  /**
   * 登录
   * @param {string} url [登录之后跳转的页面地址]
   */
  login(url = window.location.href) {
    util.replaceUrl(
      util.jumpHref("/login", { redirect_url: util.redirectUrl(url) })
    );
  },
  /**
   * 退出
   * @param {string} url [重新登录之后跳转的页面地址]
   */
  logout(url = window.location.origin) {
    this.removeToken();
    util.replaceUrl(
      util.jumpHref("/login", { redirect_url: util.redirectUrl(url), exit: 1 })
    );
  },
  /**
   * 找回密码
   * @param {string} url [重新登录之后跳转的页面地址]
   */
  forget(url = window.location.origin) {
    this.removeToken();
    // 找回密码成功后 跳会登录页
    util.replaceUrl(
      util.jumpHref("/forget", { redirect_url: util.redirectUrl(url) })
    );
  },
  /**
   * 修改密码
   */
  changepwd(url = window.location.href) {
    // 修改密码 跳会登录页
    util.replaceUrl(
      util.jumpHref("/Changepwd", { redirect_url: util.redirectUrl(url) })
    );
  },
  /**
   * 注册全局拦截器, 发起请求时在headers中注入{Authorization:token}, 相应请求时拦截302状态(请在当前工程的拦截器之前注册)
   * @param {*} axios  axios对象，
   */
  interceptors(axios, Message) {
    if (!axios) {
      throw new Error("MIS.interceptors:  axios 对象不能为空");
    }
    axios.interceptors.request.use(
      (config) => {
        let token = this.getToken();
        if (token) {
          config.headers.token = token;
        }
        config.headers['Accept-Language'] = localStorage.getItem('lang') || 'zh-CN';
        if (config.method === 'get') {
          config.paramsSerializer = function(params) {
            return qs.stringify(params, {arrayFormat: 'repeat'})
          }
        }
        return config;
      },
      error => Promise.reject(error)
    );
    axios.interceptors.response.use(
      response => {
        const data = response.data || {};
        if (data.code === 1001) {
          Message.error({
            showClose: true,
            message: data.message || "请重新登录！",
            type: "error"
          });
          this.removeToken();
          this.logout(window.location.href);
          return {};
        }
        return response;
      },
      error => {
        if (error.response && error.response.status === 401) {
          Message.error({
            showClose: true,
            message:
              (error.response.data && error.response.data.message) ||
              "请重新登录！",
            type: "error"
          });
          setTimeout(() => {
            this.removeToken();
            this.logout(window.location.href);
          }, 1000);
        } else if (error.response && error.response.status === 403) {
          location.href = '/#/403';
        }
        if (error.response && error.response.status === 500 && Message) {
          Message.error({
            showClose: true,
            message:
              (error.response.data && error.response.data.message) ||
              "网络异常！",
            type: "error"
          });
          this.$store && this.$store.commit("setPageLoading", false);
        }
        return Promise.reject(error);
      }
    );
  },
};

export default mis;

window.onstorage = function (e) {
  if (e.key === 'token' && e.newValue != mis.getToken()) {
    mis.setToken(e.newValue);
  }
}